import { StorageInterface } from '../stores/childNavStores';
import type { AccountPracInfoResponseDto } from '../types/api';

type PersistedAccountPracInfo = AccountPracInfoResponseDto & {
  _savedAt?: string;
};

export class AccountPracInfoStorage {
  private storage: StorageInterface;
  private readonly keyPrefix = 'account_prac_info_';

  constructor(storage: StorageInterface) {
    this.storage = storage;
  }

  async saveAccountPracInfo(accountId: string, dto: AccountPracInfoResponseDto): Promise<boolean> {
    try {
      const payload: PersistedAccountPracInfo = {
        ...dto,
        _savedAt: new Date().toISOString(),
      };
      await this.storage.setItem(this.keyPrefix + accountId, JSON.stringify(payload));
      return true;
    } catch (error) {
      console.error('AccountPracInfoStorage: failed to save account data', error);
      return false;
    }
  }

  async getAccountPracInfo(accountId: string): Promise<PersistedAccountPracInfo | null> {
    try {
      const raw = await this.storage.getItem(this.keyPrefix + accountId);
      if (!raw) {
        return null;
      }
      return JSON.parse(raw) as PersistedAccountPracInfo;
    } catch (error) {
      console.error('AccountPracInfoStorage: failed to load account data', error);
      return null;
    }
  }

  async clearAccountPracInfo(accountId: string): Promise<boolean> {
    try {
      await this.storage.removeItem(this.keyPrefix + accountId);
      return true;
    } catch (error) {
      console.error('AccountPracInfoStorage: failed to clear account data', error);
      return false;
    }
  }
}
